import { Blank } from "grommet-icons";

export const ThirdMedal = (props) => (
    <Blank {...props}>
        <svg fill="#000000" version="1.1" id="Layer_1" 
            viewBox="0 0 512 512">
            <g>
                <g>
                    <path d="M411.826,100.174V33.391h-66.783V0H166.957v33.391h-66.783v66.783H66.783v178.087h33.391V512h66.783v-33.391h-33.391
			V345.043h33.391v33.391h178.087v-33.391h33.391v133.565h-33.391V512h66.783V278.261h33.391V100.174H411.826z M311.652,278.261
			H200.348V244.87h77.913v-44.522h-77.913v-33.391h77.913v-33.391h-77.913v-33.391h111.304V278.261z"/>
                </g>
            </g>
            <g>
                <g>
                    <rect x="166.957" y="445.217" width="33.391" height="33.391" />
                </g>
            </g>
            <g>
                <g>
                    <rect x="278.261" y="478.609" width="33.391" height="33.391" />
                </g>
            </g>
            <g>
                <g>
                    <rect x="200.348" y="478.609" width="33.391" height="33.391" />
                </g>
            </g>
            <g>
                <g>
                    <rect x="233.739" y="445.217" width="44.522" height="33.391" />
                </g>
            </g>
            <g>
                <g>
                    <rect x="311.652" y="445.217" width="33.391" height="33.391" />
                </g>
            </g>
        </svg>
    </Blank>
);